<template>
  <b-container>
    <template v-if="$options.components['advertisement-loading']">
      <advertisement-loading v-if="isLoading" />
    </template>
    <b-row v-if="!isLoading">
      <b-col>
        <div class="main-banner">
          <img
            :src="marketBannerImage.icon.fileUrl"
            alt="Healthcare Market Banner"
          />
        </div>
        <span class="text-grey1">Home > Looking For Doctor </span>
        <sections-slider
          v-if="list && list.length"
          :list="list"
          subTitle="Health Care"
          :hasInnerBackground="true"
          :hasButton="false"
          :withSlider="true"
        >
          <template slot="default" slot-scope="{ listItem }">
            <div class="item-box">
              <items-item
                :itemLogo="true"
                :product="listItem"
                :incrementDecrementKey="false"
                :marketRoute="{
                  name: 'doctor-listing',
                  params: {
                    market: listItem.name,
                    id: listItem._id,
                    items: listItem.externalAttributes,
                  },
                }"
              ></items-item>
            </div>
          </template>
        </sections-slider>
        <sections-slider
          :list="recommendedStores"
          subTitle="Recommended Stores"
          :hasBackground="false"
          :showTitle="true"
          :hasButton="true"
          class="suggested-slider"
          :withSlider="true"
          :viewMorePage="{
            name: `health-care-listing`,
            params: {
              items: `Recommended Stores`,
            },
          }"
        >
          <template slot="default" slot-scope="{ listItem }">
            <div class="item-box ml-2 mr- 2">
              <router-link
                style="text-decoration: none; color: inherit"
                :to="{
                  name: `shopDetails`,
                  params: {
                    id: listItem._id,
                    items: listItem.office.officeName,
                  },
                }"
              >
                <items-item
                  :itemWhiteBg="true"
                  :product="listItem"
                  class="suggester-div"
                ></items-item>
              </router-link>
            </div>
          </template>
        </sections-slider>
        <sections-slider
          :list="whatsTrending"
          subTitle="Whats Trending"
          :showTitle="true"
          :hasBackground="false"
          :hasButton="true"
          class="suggested-slider"
          :withSlider="true"
          :viewMorePage="{
            name: `health-care-listing`,
            params: {
              items: `Whats Trending`,
            },
          }"
        >
          <template slot="default" slot-scope="{ listItem }">
            <div class="item-box ml-2 mr- 2">
              <items-item
                :itemNoBg="true"
                :product="listItem"
                :incrementDecrementKey="true"
                class="suggester-div"
              ></items-item>
            </div>
          </template>
        </sections-slider>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { mapState } from "vuex";

export default {
  data() {
    return { isLoading: false };
  },
  computed: {
    ...mapState({
      list: (state) => state.healthCare.specificItems,
      recommendedStores: (state) => state.healthCare.recommendedStores,
      whatsTrending: (state) => state.healthCare.trendingItems,
      marketBannerImage: (state) => state.healthCare.marketBanner,
    }),
  },

  async mounted() {
    this.isLoading = true;
    await this.$store.dispatch(
      "healthCare/fetchAllItems",
      this.$route.params.market
    );
    let bannerPayload = {
      city: "GHATAL",
      placement: "DOCTOR_MIDDLE",
    };
    await this.$store.dispatch("healthCare/fetchMarketBanner", bannerPayload);
    let recommendedStorePayload = {
      category: "SELLER",
      market: this.$route.params.marketid,
      lat: 22.6636,
      lng: 87.746,
      radius: 10,
      newlyAdded: "n",
    };
    await this.$store.dispatch(
      "healthCare/fetchRecommendedStores",
      recommendedStorePayload
    );
    await this.$store.dispatch(
      "healthCare/fetchSpecificItems",
      this.$route.params.categoryid
    );
    this.isLoading = false;
  },
};
</script>

<style scoped>
.main-banner {
  border-radius: 8px;
  margin-bottom: 20px;
}
.main-banner img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 8px;
}
</style>
